// extracted by mini-css-extract-plugin
export default {"loader":"iQ972bbClNGlkI7vcSbW","load7":"h8UWFAa5qYk3kYzYVtUk"};